import React, { useRef, useState } from 'react';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import AvatarEditor from 'react-avatar-editor';
import styled from 'styled-components';
import { colors } from '../../constants';
import Button from 'components/Button';
import { useReduxActions } from 'hooks/useReduxActions';
import Text from 'components/styled/Text';
import {
  StyledFileInputLabel,
  StyledFileInput,
} from 'components/FileFormatter/components/FileInputModal/FileInputModal';

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 530px;
`;

const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px;
  border-top: 1px solid ${colors.grey95};
`;

const UploadAvatarModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const editorRef = useRef(null);
  const actions = useReduxActions();

  const [image, setImage] = useState(null);
  const [scale, setScale] = useState(1);

  const handleSelectFile = event => {
    if (event.target.files[0]) {
      setImage(event.target.files[0]);
    }
  };

  const handleDropFile = event => {
    if (event.dataTransfer.files[0]) {
      setImage(event.dataTransfer.files[0]);
    }
    event.preventDefault();
  };

  const handleScale = event => {
    setScale(Number(event.target.value));
  };

  const handleDrag = event => {
    event.preventDefault();
  };

  const handleButtonClick = async () => {
    const canvas = editorRef.current.getImageScaledToCanvas().toDataURL();
    const blob = await fetch(canvas).then(res => res.blob());
    const formData = new FormData();
    formData.append('files', new File([blob], image.name));
    await actions.uploadAvatar(formData);
    actions.getCurrentUser();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('upload.avatar.modal.title')}>
      <ModalContainer>
        <StyledBody>
          {!image ? (
            <>
              <StyledFileInputLabel
                onDrop={handleDropFile}
                onDragOver={handleDrag}
                onDragEnter={handleDrag}
                htmlFor="file-upload">
                <Text variant="body-bold">
                  {t('upload.avatar.modal.select.file.text')}
                </Text>
                <Text variant="body-small">
                  {t('upload.avatar.modal.drag.copy.paste.file')}
                </Text>
              </StyledFileInputLabel>
              <StyledFileInput
                id="file-upload"
                type="file"
                accept={'image/x-png,image/jpeg,image/gif'}
                onChange={handleSelectFile}
                multiple
              />
            </>
          ) : (
            <>
              <AvatarEditor
                ref={editorRef}
                image={image}
                width={450}
                height={450}
                border={20}
                borderRadius={1000}
                color={[0, 0, 0, 0.55]}
                scale={scale}
                rotate={0}
              />
              <input
                type="range"
                value={scale}
                min={0.4}
                max={4}
                step={0.01}
                onChange={handleScale}
              />
            </>
          )}
        </StyledBody>
        <StyledFooter>
          <Button onClick={handleButtonClick} size="large" variant="primary">
            {t('upload.avatar.modal.button')}
          </Button>
        </StyledFooter>
      </ModalContainer>
    </Modal>
  );
};

export default UploadAvatarModal;
